import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { colors, typography } from '../../../styles';
import ContactModal from '../../ContactModal';

const styles = css`
  .ContactBanner {
    position: relative;
    padding: 45px 0;
    background-color: ${colors.neutral};
    @media (min-width: 992px) {
      padding: 90px 0 210px 0;
    }
  }
  .ContactBanner_inner {
    background-image: linear-gradient(143deg, #22517E 0%, #68C7D0 100%);
    padding: 30px;
    overflow: hidden;
    position: relative;
    @media (min-width: 992px) {
      padding: 120px;
    }
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: -200px;
      left: -200px;
      width: 650px;
      height: 650px;
      border-radius: 50%;
      background-color: ${colors.white};
      z-index: 1;
      opacity: .07;
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      right: -150px;
      bottom: -150px;
      width: 450px;
      height: 450px;
      border-radius: 50%;
      background-color: ${colors.white};
      z-index: 1;
      opacity: .07;
    }
  }
  .ContactBanner_innerPattern {
    display: block;
    position: absolute;
    right: 0;
    bottom: 0;
    width: 45%;
    height: 20%;
    background-image: ${colors.white};
    background-image: url('/images/pattern-02-light.svg');
    background-repeat: repeat;
    background-position: left top;
    z-index: 1;
  }
  .ContactBanner_content {
    position: relative;
    z-index: 2;
  }
  .ContactBanner_heading {
    font-size: 30px;
    line-height: 1;
    font-family: ${typography.Serif};
    color: ${colors.white};
    font-weight: 600;
    text-align: center;
    margin: 0 0 15px 0;
    @media (min-width: 992px) {
      font-size: 45px;
    }
  }
  .ContactBanner_title {
    font-size: 21px;
    line-height: 1;
    font-weight: 700;
    font-family: ${typography.SansSerif};
    text-transform: uppercase;
    margin: 0 0 10px 0;
    color: ${colors.white};
    text-align: center;
    @media (min-width: 992px) {
      font-size: 28px;
    }
    &::after {
      content: '';
      display: block;
      width: 150px;
      height: 2px;
      background-color: ${colors.brand2};
      margin: 30px auto;
    }
  }
  .ContactBanner_subtitle {
    font-size: 18px;
    line-height: 1.3;
    font-weight: 400;
    color: ${colors.white};
    text-align: center;
    @media (min-width: 992px) {
      font-size: 23px;
      max-width: 50%;
      margin: 0 auto;
    }
  }
  .ContactBanner_button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0;
  }
`;

function ContactBanner({ content }) {
  return (
    <div className={styles}>
      <div className="ContactBanner">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="ContactBanner_inner">
                <div className="ContactBanner_innerPattern" />
                <div className="ContactBanner_content">
                  <h3 className="ContactBanner_heading">{get(content, '[0].heading')}</h3>
                  <h4 className="ContactBanner_title">{get(content, '[0].title')}</h4>
                  <p className="ContactBanner_subtitle">{get(content, '[0].subtitle')}</p>
                  <div className="ContactBanner_button">
                    {
                      get(content, '[0].route') &&
                      <Link className="btn btn-brand3 btn-arrow-white" name={get(content, '[0].route')}>{get(content, '[0].button_text')}</Link>
                    }
                    {
                      get(content, '[0].link') &&
                      <a className="btn btn-brand3 btn-arrow-white" href={get(content, '[0].link')} target="_blank" rel="noopener noreferrer">{get(content, '[0].button_text')}</a>
                    }
                    {
                      !get(content, '[0].route') &&
                      !get(content, '[0].link') &&
                      <ContactModal>
                        <span className="btn btn-brand3 btn-arrow-white">{get(content, '[0].button_text')}</span>
                      </ContactModal>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ContactBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ContactBanner;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/ContactBanner.section.js